import { AppRouter } from "../enums/AppRouter";

export const getCurrentPage = (path: string[]): AppRouter => {
  if (path[0] === "login") {
    return AppRouter.Login;
  }
  if (path[0] === "gallery") {
    return path[1] ? AppRouter.Game : AppRouter.Gallery;
  }
  if (path[0] === "mygames") {
    return path[1] ? AppRouter.Constructor : AppRouter.MyGames;
  }
  return AppRouter.NotFoundPage;
};
